let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3qsjq")).then(() => parcelRequire('kfYj7'));